import { render, staticRenderFns } from "./AuthorProfileThumb.vue?vue&type=template&id=a0c0e13a&scoped=true"
import script from "./AuthorProfileThumb.vue?vue&type=script&lang=js"
export * from "./AuthorProfileThumb.vue?vue&type=script&lang=js"
import style0 from "./AuthorProfileThumb.vue?vue&type=style&index=0&id=a0c0e13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c0e13a",
  null
  
)

export default component.exports